/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap as cssMapCompiled, jsx } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import { token } from '@atlaskit/tokens';

import { messages } from '../i18n';
import AccessLockSVG from '../icons/AccessLockSVG';

const compiledStyles = cssMapCompiled({
	accessLockSVGWrapper: {
		marginBottom: token('space.600'),
	},
	actionButtonWrapper: {
		marginTop: token('space.100'),
	},
});

const NoAccessErrorState = ({ onAction }: { onAction: () => void }): React.JSX.Element => {
	const intl = useIntl();

	const action = (
		<div css={compiledStyles.actionButtonWrapper}>
			<Button onClick={onAction} appearance="primary">
				<FormattedMessage {...messages.noAccessErrorStateActionLabel} />
			</Button>
		</div>
	);

	return (
		<EmptyState
			header={intl.formatMessage(messages.noAccessErrorStateTitle)}
			description={intl.formatMessage(messages.noAccessErrorStateMessage)}
			primaryAction={action}
			renderImage={() => (
				<div css={compiledStyles.accessLockSVGWrapper}>
					<AccessLockSVG />
				</div>
			)}
		/>
	);
};

export default NoAccessErrorState;
